'use client';

import { c as _c } from "react/compiler-runtime";
import { UK_REGIONS } from '@repo/sdk/constants';
import { FieldContent, Tags, TagsContent, TagsEmpty, TagsGroup, TagsInput, TagsItem, TagsList, TagsTrigger, TagsValue } from '@repo/ui/components';
import { CheckIcon } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { AnimatePresence, motion } from '@repo/ui/motion';
import { useState } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
interface FormUkRegionsTagsInputProps {
  container?: HTMLElement | null;
  contentClassName?: string;
  onRegionAdd?: (code: string) => void;
  onRegionRemove?: (code: string) => void;
  onRegionsChange?: () => void;
  variant?: 'ghost' | 'outline';
}
export const FormUkRegionsTagsInput = t0 => {
  const $ = _c(113);
  const {
    container,
    contentClassName,
    onRegionAdd,
    onRegionRemove,
    onRegionsChange,
    variant: variantProp
  } = t0;
  const field = useFieldContext();
  const isReadOnly = useReadOnly();
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== field.state.value) {
    t1 = field.state.value ?? [];
    $[0] = field.state.value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selected = t1;
  let t2;
  if ($[2] !== field || $[3] !== onRegionRemove || $[4] !== onRegionsChange || $[5] !== selected) {
    t2 = code => {
      if (!selected.includes(code)) {
        return;
      }
      const newValue = selected.filter(v => v !== code);
      field.handleChange(newValue);
      onRegionRemove?.(code);
      onRegionsChange?.();
    };
    $[2] = field;
    $[3] = onRegionRemove;
    $[4] = onRegionsChange;
    $[5] = selected;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleRemove = t2;
  let t3;
  if ($[7] !== field || $[8] !== handleRemove || $[9] !== onRegionAdd || $[10] !== onRegionsChange || $[11] !== selected) {
    t3 = code_0 => {
      if (selected.includes(code_0)) {
        handleRemove(code_0);
        return;
      }
      const newValue_0 = [...selected, code_0];
      field.handleChange(newValue_0);
      onRegionAdd?.(code_0);
      onRegionsChange?.();
    };
    $[7] = field;
    $[8] = handleRemove;
    $[9] = onRegionAdd;
    $[10] = onRegionsChange;
    $[11] = selected;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleSelect = t3;
  if (isReadOnly) {
    let t4;
    if ($[13] !== selected) {
      t4 = selected.join(", ") || "-";
      $[13] = selected;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    let t5;
    if ($[15] !== t4) {
      t5 = <ReadOnlyTooltip>{t4}</ReadOnlyTooltip>;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t4;
  if ($[17] !== handleRemove || $[18] !== isOpen || $[19] !== selected) {
    t4 = isOpen ? selected.map(code_1 => <TagsValue key={code_1} onRemove={() => handleRemove(code_1)} variant="outline">{code_1}</TagsValue>) : <span className="text-left text-base font-normal text-wrap">{selected.join(", ")}</span>;
    $[17] = handleRemove;
    $[18] = isOpen;
    $[19] = selected;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const selectedValue = t4;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[21] !== container || $[22] !== contentClassName || $[23] !== handleSelect || $[24] !== isOpen || $[25] !== search || $[26] !== selected || $[27] !== selectedValue || $[28] !== variantProp) {
    let t27;
    if ($[56] !== search) {
      t27 = region => !search.trim() || region.toLowerCase().includes(search.trim().toLowerCase());
      $[56] = search;
      $[57] = t27;
    } else {
      t27 = $[57];
    }
    const filteredRegions = UK_REGIONS.filter(t27);
    T4 = FieldContent;
    t24 = "FieldContent";
    t25 = "FormUkRegionsTagsInput";
    t26 = "form-uk-regions-tags-input.tsx";
    T3 = Tags;
    t16 = "w-full";
    t17 = setIsOpen;
    t18 = isOpen;
    t19 = setSearch;
    t20 = search;
    t21 = "Tags";
    t22 = "form-uk-regions-tags-input.tsx";
    const t28 = !isOpen && !variantProp && "p-0";
    let t29;
    if ($[58] !== t28) {
      t29 = cn(t28, "transition-all duration-100");
      $[58] = t28;
      $[59] = t29;
    } else {
      t29 = $[59];
    }
    const t30 = variantProp ?? (!isOpen ? "ghost" : "outline");
    let t31;
    if ($[60] !== selected.length || $[61] !== selectedValue) {
      t31 = selected.length === 0 ? <span className="text-muted-foreground">-</span> : selectedValue;
      $[60] = selected.length;
      $[61] = selectedValue;
      $[62] = t31;
    } else {
      t31 = $[62];
    }
    let t32;
    if ($[63] !== isOpen) {
      t32 = isOpen && <motion.span animate={{
        opacity: 1
      }} className="text-muted-foreground px-2 py-px" exit={{
        opacity: 0
      }} initial={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }}>Select UK regions...</motion.span>;
      $[63] = isOpen;
      $[64] = t32;
    } else {
      t32 = $[64];
    }
    let t33;
    if ($[65] !== t32) {
      t33 = <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="form-uk-regions-tags-input.tsx">{t32}</AnimatePresence>;
      $[65] = t32;
      $[66] = t33;
    } else {
      t33 = $[66];
    }
    if ($[67] !== t29 || $[68] !== t30 || $[69] !== t31 || $[70] !== t33) {
      t23 = <TagsTrigger className={t29} variant={t30} data-sentry-element="TagsTrigger" data-sentry-source-file="form-uk-regions-tags-input.tsx">{t31}{t33}</TagsTrigger>;
      $[67] = t29;
      $[68] = t30;
      $[69] = t31;
      $[70] = t33;
      $[71] = t23;
    } else {
      t23 = $[71];
    }
    T2 = TagsContent;
    t11 = contentClassName;
    t12 = container;
    t13 = "TagsContent";
    t14 = "form-uk-regions-tags-input.tsx";
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <TagsInput onValueChange={setSearch} placeholder="Search region..." data-sentry-element="TagsInput" data-sentry-source-file="form-uk-regions-tags-input.tsx" />;
      $[72] = t15;
    } else {
      t15 = $[72];
    }
    T1 = TagsList;
    t8 = "TagsList";
    t9 = "form-uk-regions-tags-input.tsx";
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <TagsEmpty data-sentry-element="TagsEmpty" data-sentry-source-file="form-uk-regions-tags-input.tsx"><span className="text-muted-foreground text-sm">No regions found</span></TagsEmpty>;
      $[73] = t10;
    } else {
      t10 = $[73];
    }
    T0 = TagsGroup;
    t5 = "TagsGroup";
    t6 = "form-uk-regions-tags-input.tsx";
    let t34;
    if ($[74] !== handleSelect || $[75] !== selected) {
      t34 = region_0 => <TagsItem key={region_0} onSelect={handleSelect} value={region_0}>{region_0}{selected.includes(region_0) && <CheckIcon className="text-muted-foreground" size={14} />}</TagsItem>;
      $[74] = handleSelect;
      $[75] = selected;
      $[76] = t34;
    } else {
      t34 = $[76];
    }
    t7 = filteredRegions.map(t34);
    $[21] = container;
    $[22] = contentClassName;
    $[23] = handleSelect;
    $[24] = isOpen;
    $[25] = search;
    $[26] = selected;
    $[27] = selectedValue;
    $[28] = variantProp;
    $[29] = T0;
    $[30] = T1;
    $[31] = T2;
    $[32] = T3;
    $[33] = T4;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
    $[50] = t26;
    $[51] = t5;
    $[52] = t6;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
  } else {
    T0 = $[29];
    T1 = $[30];
    T2 = $[31];
    T3 = $[32];
    T4 = $[33];
    t10 = $[34];
    t11 = $[35];
    t12 = $[36];
    t13 = $[37];
    t14 = $[38];
    t15 = $[39];
    t16 = $[40];
    t17 = $[41];
    t18 = $[42];
    t19 = $[43];
    t20 = $[44];
    t21 = $[45];
    t22 = $[46];
    t23 = $[47];
    t24 = $[48];
    t25 = $[49];
    t26 = $[50];
    t5 = $[51];
    t6 = $[52];
    t7 = $[53];
    t8 = $[54];
    t9 = $[55];
  }
  let t27;
  if ($[77] !== T0 || $[78] !== t5 || $[79] !== t6 || $[80] !== t7) {
    t27 = <T0 data-sentry-element={t5} data-sentry-source-file={t6}>{t7}</T0>;
    $[77] = T0;
    $[78] = t5;
    $[79] = t6;
    $[80] = t7;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] !== T1 || $[83] !== t10 || $[84] !== t27 || $[85] !== t8 || $[86] !== t9) {
    t28 = <T1 data-sentry-element={t8} data-sentry-source-file={t9}>{t10}{t27}</T1>;
    $[82] = T1;
    $[83] = t10;
    $[84] = t27;
    $[85] = t8;
    $[86] = t9;
    $[87] = t28;
  } else {
    t28 = $[87];
  }
  let t29;
  if ($[88] !== T2 || $[89] !== t11 || $[90] !== t12 || $[91] !== t13 || $[92] !== t14 || $[93] !== t15 || $[94] !== t28) {
    t29 = <T2 className={t11} container={t12} data-sentry-element={t13} data-sentry-source-file={t14}>{t15}{t28}</T2>;
    $[88] = T2;
    $[89] = t11;
    $[90] = t12;
    $[91] = t13;
    $[92] = t14;
    $[93] = t15;
    $[94] = t28;
    $[95] = t29;
  } else {
    t29 = $[95];
  }
  let t30;
  if ($[96] !== T3 || $[97] !== t16 || $[98] !== t17 || $[99] !== t18 || $[100] !== t19 || $[101] !== t20 || $[102] !== t21 || $[103] !== t22 || $[104] !== t23 || $[105] !== t29) {
    t30 = <T3 className={t16} onOpenChange={t17} open={t18} setValue={t19} value={t20} data-sentry-element={t21} data-sentry-source-file={t22}>{t23}{t29}</T3>;
    $[96] = T3;
    $[97] = t16;
    $[98] = t17;
    $[99] = t18;
    $[100] = t19;
    $[101] = t20;
    $[102] = t21;
    $[103] = t22;
    $[104] = t23;
    $[105] = t29;
    $[106] = t30;
  } else {
    t30 = $[106];
  }
  let t31;
  if ($[107] !== T4 || $[108] !== t24 || $[109] !== t25 || $[110] !== t26 || $[111] !== t30) {
    t31 = <T4 data-sentry-element={t24} data-sentry-component={t25} data-sentry-source-file={t26}>{t30}</T4>;
    $[107] = T4;
    $[108] = t24;
    $[109] = t25;
    $[110] = t26;
    $[111] = t30;
    $[112] = t31;
  } else {
    t31 = $[112];
  }
  return t31;
};